/* eslint-disable */
import { resourceGroups } from "../data/constants";
import validate from "validate.js";
import { ITask, IAction } from "../modules/ninVerification/types";
import { ITinVerificationResponse } from "../app/modules/kyc/ITinVerificationResponse";
import {IAddress} from "../app/modules/kyc/company/interfaces/ICompanyProfile";
import moment from "moment";

export interface IRole {
  role: string | string[];
}
export const checkUserRole = (role: IRole, resource: string) => {
  let resourceExists = false;
  if (Array.isArray(role)) {
    resourceExists = checkRoleArray(role, resource);
  } else {
    resourceExists = checkRoleString(`${role}`, resource);
  }
  return resourceExists;
};
const checkRoleString = (role: string, resource: string) => {
  const roleItem = role.toLowerCase();
  if (resourceGroups[roleItem] && resourceGroups[roleItem].includes(resource))
    return true;
  return false;
};
const checkRoleArray = (role: string[], resource: string) => {
  for (let i = 0; i < role.length; i++) {
    const roleItem = role[i].toLowerCase();
    if (
      resourceGroups[roleItem] &&
      resourceGroups[roleItem].includes(resource)
    ) {
      return true;
    }
  }
  return false;
};

export const checkRoleAvailability = (
  role: IRole,
  availableRoles: string[]
) => {
  let resourceExists = false;
  if (Array.isArray(role)) {
    resourceExists = role.some((role: any) =>
      availableRoles.includes(role.toLowerCase())
    );
  } else {
    resourceExists = availableRoles.includes(`${role}`.toLowerCase());
  }
  return resourceExists;
};

export const tinStatusDetails = (status: any) => {
  switch (status) {
    case "Successful":
      return { pillClass: "badge-light-success", label: "Found" };

    case "Error":
      return { pillClass: "badge-light-danger", label: "Not Found" };

    default:
      return { pillClass: "badge-light-warning", label: "Pending" };
  }
};

export const tinSummary = (errorCode?: string, description?: string) => {
  switch (errorCode) {
    case "E000":
      return {
        status: "success",
        label: "TIN verification successful",
        description: "Found",
        labelClass: "text-success",
      };

    default:
      return {
        // status: 'error',
        // label: "TIN verification failed",
        // labelClass: "text-danger",
        // description: description
      };
  }
};

export const companyStatusDetails = (status: any) => {
  switch (status) {
    case "Successful":
    case "SUCCESS":
    case 'Registered':
    case 'Active':
      return { pillClass: "badge-light-success", label: "Found", tooltip: 'Registration Number matches URSB records' };
    case 'Approved':
      return { pillClass: "badge-light-success", label: "Approved", tooltip: 'Reviewed & accepted. Business can operate legally' };
    case "Error":
    case "Not Found":
    case null:
      return { pillClass: "badge-light-danger", label: "Not Found", tooltip: "Registration number does not match any URSB records" };
    
    case "inProgress":
      return { pillClass: "", label: "", tooltip: "In progress. Please wait" };

    default:
      return { pillClass: "badge-light-warning", label: "Pending", tooltip: "Please wait" }
  }
};

export const cardStatusDetails = (status: any) => {
  switch (status) {
    case true:
      return { pillClass: "badge-light-success", label: "Match" };

    case false:
      return { pillClass: "badge-light-danger", label: "Mismatch" };

    default:
      return { pillClass: "", label: "" };
  }
};

export const verificationSummary = (status: any) => {
  switch (status) {
    case true:
      return 'Provided ID details are consistent with NIRA records';

    case false:
      return 'Not all the information on the ID match NIRA records';
    case null:
      return 'Information on the ID does not match NIRA records';

    case 'valid':
      return 'ID Document is authentic';

    case 'invalid':
      return 'ID Document is not authentic';

    default:
      return 'ID data was not verified';
  }
};

export const livenessDetectionDetails = (status: any) => {
  switch (status) {
    case true:
      return { pillClass: "badge-light-success", label: "Liveness Verified" };

    case false:
      return { pillClass: "badge-light-danger", label: "Liveness Failed" };

    case 'Not Processed':
      return { pillClass: "badge-dark", label: "Not Processed"};

    default:
      return { pillClass: "badge-light-dark", label: "Unavailable" };
  }
};

export const photoMatchDetails = (status: any) => {
  switch (status) {
    case true:
      return { pillClass: "badge-light-success", label: "Match" };

    case false:
      return { pillClass: "badge-light-danger", label: "No Match" };

    case 'Not Processed':
      return { pillClass: "badge-dark", label: "Not Processed"};
  
    default:
      return { pillClass: "badge-light-dark", label: "Unavailable" };
  }
};

export const ninStatusDetails = (status: any) => {

    if (status?.length > 30 && status?.length < 100) {
        status = 'Not Found'
    }
    switch (status) {
      case 'Ok':
        return {pillClass: 'badge-light-success', label: 'Valid', tooltip: "Success! NIN found in NIRA database"}
      case 'Not Found':
        return {pillClass: 'badge-light-danger', label: 'Not Found', tooltip: "NIN can not be found in NIRA database"}
      case 'deceased':
        return {pillClass: 'badge-dark', label: 'Deceased', tooltip: "Citizen is deceased"}
      case 'not citizen':
        return {pillClass: 'badge-danger', label: 'Not Citizen', tooltip: "Not a registered citizen as per NIRA"}
      default:
        return {pillClass: 'badge-light-danger', label: 'Error', tooltip: "Something wrong happened. Please try again"}
    }
}

export const cardNumberStatus = (status: any) => {
    switch (status) {
      case 'Valid':
      case 'valid':
        return {pillClass: 'badge-light-success', label: 'Valid', tooltip: "Success! Valid ID Number"}
      case 'Not Active':
        return {pillClass: 'badge-light-danger', label: 'Not Active', tooltip: "ID Number is not active"}
      case 'Not valid':
      case 'invalid':
        return {pillClass: 'badge-light-danger', label: 'Not Valid', tooltip: "ID Number is invalid"}
      case 'Error':
        return {pillClass: 'badge-light-danger', label: 'Not Found', tooltip: "ID number does not match any records"}
      case 'Expired':
        return {pillClass: 'badge-light-danger', label: 'Expired', tooltip: "ID card is expired"}
      default:
        return {pillClass: 'badge-light-warning', label: 'Pending', tooltip: "Processing still pending"}
    }
};

export const companyKCCAStatus = (status: any) => {
  switch (status) {
    case 'verified success':
    case 'active':
      return {pillClass: 'badge-light-success', label: 'Active'}
    case 'Error':
      return {pillClass: 'badge-light-danger', label: 'Not Found'}
    default:
      return {pillClass: 'badge-light-danger', label: 'Not Found'}
  }
};

export const workflowOverallStatus = (status: any) => {
  switch (status) {
    case "Closed":
      return { pillClass: "badge-light-success", label: "Closed" };

    case "Open":
      return { pillClass: "badge-light-warning", label: "Open" };

    case "Error":
      return { pillClass: "badge-light-danger", label: "Error" };

    default:
      return { pillClass: "badge-light-danger", label: "Error" };
  }
};

export const COpersonWorkflowStatus = (status: any) => {
  switch (status) {
    case "Received":
      return { pillClass: "badge-light-warning", label: "Received" };

    case "PendingApproval":
      return { pillClass: "badge-light-dark", label: "Pending Approval" };

    case "Processing":
      return { pillClass: "badge-light-dark", label: "Processing" };

    case "Declined":
      return { pillClass: "badge-light-danger", label: "Declined" };

    case "Completed":
      return { pillClass: "badge-light-success", label: "Completed" };

    default:
      return { pillClass: "badge-light-danger", label: "Pending" };
  }
};

export const phoneNumberStatus = (state: any) => {
  switch (state) {
    case 0:
    case 'Invalid':
      return { pillClass: "badge-light-danger", label: "Not Found", tooltip: "Phone number does not match any records" };

    case 1:
    case 'Valid':
      return { pillClass: "badge-light-success", label: "Found", tooltip: "Verification successful! Records indicate that this phone number is currently active" };

    case 'Unknown':
      return { pillClass: "badge-light-danger", label: "Verification Failed", tooltip: "Failed to verify phone number" };
    default:
      return { pillClass: "badge-light-danger", label: "Error", tooltip: "Something wrong happened. Please try again"};
  }
};

export const isOwnerPNStatus = (status: any) => {
  switch (status) {
    case true:
      return { pillClass: "badge-light-success", label: "Match", tooltip: "Verification successful! Phone number & ID corresponds with database record" };
    case false:
      return { pillClass: "badge-light-danger", label: "Mismatch", tooltip: "Unable to find a matching record for this phone number" };
    case null:
      return { pillClass: "badge-light-danger", label: "Not Found", tooltip: "We couldn't locate this phone number & ID" };
    default:
      return { pillClass: "badge-light-danger", label: "Error", tooltip: "Something wrong happened. Please try again" };
  }
};

export const emailStatus = (state: any) => {
  switch (state) {
    case 'invalid':
      return { pillClass: "badge-light-danger", label: "Invalid", tooltip: "Email does not match any records" };
    case 'valid':
      return { pillClass: "badge-light-success", label: "Valid", tooltip: "Verification successful! Records indicate that this Email is currently active" };
    case 'unknown':
      return { pillClass: "badge-light-danger", label: "Uncertain", tooltip: "Failed to verify Email" };
    default:
      return { pillClass: "badge-light-danger", label: "Error", tooltip: "Something wrong happened. Please try again"};
  }
};

export const parseJson = (data: any) => {
  try {
    return typeof data === 'string' ? JSON.parse(data) : data;
  } catch (e) {
    return "";
  }
};

export const parseTaskStatus = (st: any) => {
  switch (st) {
    case 0:
      return "Pending";
    case 1:
      return "Successful";
    case -1:
      return "Error";
    default:
      return "Error";
  }
};

export const readActionOutPut = (
  taskName: string,
  tasks: Array<ITask>,
  actionList: any
) => {
  const task = tasks.filter((it) => it.name === taskName)[0];
  if (task) {
    const { actions = [] } = task;
    const reqActions = actions.filter((it) => actionList.indexOf(it.name) >= 0);
    let data = undefined;
    for (let i = 0; i < reqActions.length; i++) {
      const action = reqActions[i];
      const { outputData } = action;
      if (!validate.isEmpty(outputData)) {
        data = parseJson(outputData);
        if (data) {
          data["status"] = action.status;
          data["statusLabel"] = parseTaskStatus(action.status);
          data["statusMessage"] = action.statusMessage;
          data["runDate"] = action.runDate;
          data["id"] = action.id;
        }
        if (actionList.length === 1) {
          //This caters for cases where we can have optional actions
          break;
        }
      }
    }
    return data;
  } else {
    return undefined;
  }
};

export const readActionOutPutStatusIDV = (
  actions: Array<IAction>,
  actionName: any
) => {
  const reqActions: any = actions.filter(
    (it) => actionName.indexOf(it.name) >= 0
  );
  let data = undefined;
  if (reqActions.length >= 1) {
    if (reqActions[0].statusMessage === "Skipped Action") {
      reqActions[0].status = "Skipped";
    }

    const { status, statusMessage } = reqActions[0];
    data = { status, statusMessage };
  }
  return data;
};

export const readActionOutPutStatus = (
  actions: Array<IAction>,
  actionName: any
) => {
  const reqActions: any = actions?.find((q: any) => q.name === actionName);

  let data = undefined;
  if (reqActions) {
    if (reqActions?.outputData) {
      const outputData = JSON.parse(reqActions?.outputData);

      if (outputData?.errors) {
        return {
          status: "Error",
          statusMessage: outputData?.errors?.Tin[0],
        };
      }

      if (
        outputData?.isError ||
        outputData?.ursbErrorCode == "ENTITY_NOT_FOUND"
      ) {
        return { status: "Not Found", statusMessage: "" };
      }
    }

    if (reqActions.statusMessage === "Skipped Action") {
      reqActions.status = "Skipped";
    }

    const { status, statusMessage } = reqActions;
    data = { status, statusMessage };
  }

  return data;
};

export const readTinVerificationOutput = (actions: Array<IAction>) => {
  const outputData = actions?.find(
    (q: any) => q.name === "tin-verification-request"
  )?.outputData;
  if (outputData) {
    return JSON.parse(outputData);
  } else return undefined;
};

export const readUrsbVerificationOutput = (actions: Array<IAction>) => {
  const outputData = actions?.find(
    (q: any) => q.name === "ursb-verification-request"
  )?.outputData;
  if (outputData) {
    return JSON.parse(outputData);
  } else return undefined;
};

export const readKccaLicenseOutput = (actions: Array<IAction>) => {
  const outputData = actions?.find(
    (q: any) => q.name === "kcca-licence-request"
  )?.outputData;
  if (outputData) {
    return JSON.parse(outputData);
  } else return undefined;
};

export const getInitials = (name: string) => {
  const [firstname, lastname, othername] = name.toUpperCase().split(" ");

  const FN = firstname ? firstname?.substring(0, 1) : ''
  const LN = lastname ? lastname?.substring(0, 1) : ''
  const ON = othername ? othername?.substring(0, 1) : ''

  return `${FN}${LN}${ON}`;
};

export const splitFullName = (name: string) => {
  if (name.includes("SLF")) {
    return null;
  }
  const nameArr = name?.split(" ")
  
  let fullName: any
  if (nameArr?.length){
      const otherName = nameArr.length > 2 ? ' ' + nameArr[2] : '';
      
       fullName = {
          surname: nameArr[0],
          givenName: nameArr.length > 1 ? nameArr[1] + otherName : ''
      }
  }
  return fullName
};

export const splitCamelCase = (caseString: string) => {
  if (caseString) {
    return caseString.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
  }
  return caseString
}

export const triggerCSVDownload = (data: Blob, fileName = "export.csv") => {
  const a = document.createElement("a");
  a.href = window.URL.createObjectURL(data);
  a.download = fileName;
  a.click();
};

export const triggerFileDownload = (data: Blob, fileName = "Export.zip") => {
  const a = document.createElement("a");
  a.href = window.URL.createObjectURL(data);
  a.download = fileName;
  a.click();
};


export const setTaskStatus = (taskStatus: any, size: any = null) => {

  switch (taskStatus) {
    case true:
    case 'ACTIVE':
      return {colorCode: 'success', icon: 'arrows/arr085', size: size ?? 'meduim', toolTip: 'Verification successful'}

    case false:
      return {colorCode: 'danger', icon: 'general/gen044', size: size ?? 'meduim', toolTip: 'Needs review'}

    case 'Edited':
    case 'hasData':
      return {colorCode: 'warning', icon: 'general/gen044', size: size ?? 'meduim', toolTip: 'Data entered but not verified'}

    case 'skipped':
    case 'error':
      return {colorCode: 'warning', icon: 'general/gen044', size: size ?? 'meduim', toolTip: 'Something went wrong'}

    case 'Pending':
    case 'inProgress':
      return {colorCode: 'danger', icon: 'inProgress', size: size ?? 'meduim'}

    case 'Missing':
      return {colorCode: 'dark', icon: 'files/fil006', size: size ?? 'small', toolTip: 'Data missing'}

    default:
      return {colorCode: 'warning', icon: 'general/gen044', size: size ?? 'default', toolTip: 'Something went wrong'}
  }
}

export const setLivenesStatus = (taskStatus: any, size: any = null) => {
  switch (taskStatus) {
    case true:
      return {colorCode: 'success', icon: 'arrows/arr085', size: size ?? 'meduim'}
    case false:
      return {colorCode: 'danger', icon: 'general/gen044', size: size ?? 'meduim'}
    case 'Missing':
      return {colorCode: 'warning', icon: 'general/gen044', size: size ?? 'meduim'}
    default:
      return {colorCode: 'warning', icon: 'general/gen044', size: size ?? 'default'}
  }
}

export const setBiometricStatus = (taskStatus: any, size: any = null) => {
  switch (taskStatus) {
    case true:
      return {colorCode: 'success', icon: 'arrows/arr085', size: size ?? 'meduim'}

    case false:
      return {colorCode: 'danger', icon: 'general/gen044', size: size ?? 'default'}

    default:
      return {colorCode: 'danger', icon: 'general/gen044', size: size ?? 'default'}
  }

}

export const setTransactionStatus = (taskStatus: any, size: any = null) => {

  switch (taskStatus) {
    case 'Completed':
    case 'KycSubmitted':
      return {colorCode: 'success', icon: 'arrows/arr085', size: size ?? 'meduim', toolTip: 'Transaction completed successfully'}

    case 'Failed':
    case 'KycFailed':
      return {colorCode: 'danger', icon: 'general/gen044', size: size ?? 'meduim', toolTip: 'Transaction failed!'}

    case 'KycFailed':
      return {colorCode: 'danger', icon: 'general/gen044', size: size ?? 'meduim', toolTip: 'KYC checks failed'}

    case 'PaymentFailed':
      return {colorCode: 'danger', icon: 'general/gen044', size: size ?? 'meduim', toolTip: 'Payment failed. Please re-try'}

    case 'Submitted':
    case 'Priced':
      return {colorCode: 'warning', icon: 'general/gen044', size: size ?? 'meduim', toolTip: 'Transaction has been submitted'}

    case 'AwaitingPayment':
      return {colorCode: 'dark', icon: 'abstract/abs019', size: size ?? 'meduim', toolTip: 'Awaiting payment processing...'}

    case 'skipped':
    case 'error':
      return {colorCode: 'warning', icon: 'general/gen044', size: size ?? 'meduim', toolTip: 'Something went wrong'}

    case 'Processing':
    case 'Pending':
    case 'AwaitingKycCheck':
      return {colorCode: 'danger', icon: 'inProgress', size: size ?? 'meduim', toolTip: 'Processing...'}

    default:
      return {colorCode: 'warning', icon: 'general/gen044', size: size ?? 'default', toolTip: 'Something went wrong'}
  }
}

export const formatAddress = (address: IAddress) => {
  if(!address.country && !address.district) return '-'
  return `${address.country || ''}${', ' + address.district || ''} ${address.county || ''} ${address.parish || ''} ${address.village || ''}`.toUpperCase()
}

export const NationalIDExpiryStatus = (expiryDate: Date) => {
  if (expiryDate > new Date()) {
    return 'Active'
  } else {
    return 'Expired'
  }
}

export const riskProfileClass = (riskClass: string) => {
  switch (riskClass) {
    case 'Low':
      return { pillClass: "badge-light-success", label: "Low Risk" };

    case 'Medium':
      return { pillClass: "badge-light-warning", label: "Medium Risk" };

    case 'High':
      return { pillClass: "badge-light-danger", label: "High Risk" };

    default:
      return { pillClass: "badge-light-dark", label: "Missing Data" };
  }
}

export const bulkRequestStatus = (requestStatus: string) => {
  switch (requestStatus) {
    case 'Successful':
      return { pillClass: "badge-light-success", label: "Completed" };

    case 'Failed':
      return { pillClass: "badge-light-danger", label: "Failed" };

    case 'Pending':
      return { pillClass: "badge-light-dark", label: "Processing" };

    case 'Error':
      return { pillClass: "badge-light-danger", label: "Error" };

    default:
      return { pillClass: "badge-light-danger", label: "Error" };
  }
}

export const driverRestrictionFix = (code: string) => {
  
  switch (code) {
    case 'WONE':
    case 'N':
    case 'NO':
    case 'N NON':
    case '0':
    case 'MONE':
    case 'NOE':
      return 'NONE';
    default:
      return code;
  }
}

export const phoneNumberMask = [ /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/]

export const phoneNumberInbound = (phoneNumber: string) => {

  let formattedPN:string = phoneNumber.replace(/^(?:\+?256|0)/, "")
  let newPN
  if (formattedPN.length > 0) {
    newPN = formattedPN?.match(new RegExp('.{1,3}', 'g'))?.join(" ")
  }
  return newPN
}

export const phoneNumberOutbound = (phoneNumber: string) => {

  if (phoneNumber.length > 0) {
    let newPN = phoneNumber.replaceAll(' ', '');
    return `+256${newPN}`
  }
  return phoneNumber
}

export const formatPhoneNumber = (phoneStr:string) => {
  if (!phoneStr) return '';
  const formatted = phoneStr.replace(/(\d{3})(?=\d)/g, '$1 ');
  return `+${formatted}`;
};

// Example Usage:
// const input = "256753600023";
// console.log(formatPhoneNumber(input)); // Output: "+256 753 600 023"

export const getPhoneNumberVerfication = (phoneNumber: string, verficationData:any) => {
  return verficationData?.find((q: any) => q.value === phoneNumber)
}

export const getPhoneNumberSwapCheck = (phoneNumber: string, verficationData:any) => {
  let S = verficationData?.find((q: any) => q.value === phoneNumber && q.vendorCode === 'STRM_02')
  if (!S?.value) {
    return
  }
  return JSON.parse(S?.response?.responsePayload)
}

export const checkProvider = (phoneNumber:string) => {
  const provider = phoneNumber.match(/2567[6-8]\d{3}\d{4}$/)
  if (provider) {
      return true
  }
  return false
}

export const getEmailVerfication = (email: string, verficationData:any) => {
  if (!email) return
  return verficationData?.find((q: any) => q.value === email)
}

export const verificationTypeDownload = (type: any) => {
  switch (type) {
    case 'IDV':
      return 'ID Verifications'
    case 'PNV':
      return 'Phone Number Verifications'
    case 'AMLPEP':
      return 'AML-PEP Verifications'
    case 'CO':
      return 'Person Applications'
    case 'BNV':
      return 'Company Searches'
    case 'KCCA':
      return 'KCCA Trade License Verifications'
    case 'AML':
      return 'AML Screenings'
    case 'TIN':
      return 'TIN Verifications'
    case 'BULKPERSONKYC':
      return 'Bulk Verifications Export'
    default:
      return 'File'
  }
}

export const documentTypeToReadable = (type: any) => {
  switch (type) {
    case 'customerSignature':
    case 'Customer Signature':
      return 'Signature'
    case 'passportPhoto':
    case 'Passport Photo':
      return 'Photo'
    case 'nationalId':
    case 'nationalid':
      return 'National ID'
    case 'proofOfEmployment':
      return 'Employment'
    case 'passport':
      return 'Passport'
    case 'drivingLicence':
    case 'driving-licence':
      return 'Driving Licence'
    default:
      return 'Document'
  }
}

export const calculateDaysPast = (initialDate: any) => {
  if (!initialDate) {
    return null
  }
  var ago = moment.duration(moment().diff(initialDate)).humanize() + " ago";
  return ago
}

export const personAge = (dateOfBirth: string) => {
  dateOfBirth = moment(dateOfBirth, ['DD.MM.YYYY', 'YYYY-MM-DD']).format("YYYY-MM-DD")
  const years = moment().diff(dateOfBirth, 'years');
  if (!years) return
  return `— ${years}yrs`
}

export const checkExpiryDate = (expiryDate: any) => {
  if (!expiryDate) {
    return null
  }

  expiryDate = moment(expiryDate, ['DD.MM.YYYY', 'YYYY-MM-DD']).format("YYYY-MM-DD")
  const E = moment(expiryDate).isAfter(new Date())
  
  if (E) {
    return false
  } else return true
}

export const checkIfMinor = (dateOfBirth: any) => {
  dateOfBirth = moment(dateOfBirth, ['DD.MM.YYYY', 'YYYY-MM-DD']).format("YYYY-MM-DD")
  const years = moment().diff(dateOfBirth, 'years');
  if (years < 18) {
    return true
  }
  return false
}

export const humanReadbleFileSize = (bytes: number): `${number} ${'B' | 'KB' | 'MB' | 'GB' | 'TB'}` => {
  const index = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${Number((bytes / Math.pow(1024, index)).toFixed(2)) * 1} ${(['B', 'KB', 'MB', 'GB', 'TB'] as const)[index]}`;
};

export const notificationType = (st: any) => {
  switch (st) {
    case 0:
      return "Feature Release";
    case 1:
      return "Maintenance";
    case 2:
      return "Alert";
    case 3:
      return "Reminder";
    case 4:
      return "Update";
    default:
      return "Default";
  }
}

export const validationStepsStateClass = (status: any) => {
  switch (status) {
    case 'pending':
      return 'text-secondary';
    case 'inProgress':
      return 'spinner-border spinner-border-sm align-middle ms-2 text-dark';
    case 'done':
      return 'text-success';
    case 'failed':
      return 'text-danger';
    default:
      return '';
  }
};

export const formatRoleNames = (role:string) => {
  switch (role) {
    case 'checker':
      return 'Checker'
    case 'maker':
      return 'Maker'
    // case 'default-roles-streamline-test-realm':
    //   return 'Portal Administrator'

    default:
      return ''
  }

}

export const formatBadError = (errorString: string) => {
  const jsonStartIndex = errorString.indexOf('{'); 
  const jsonSubstring = errorString.substring(jsonStartIndex); 
  try {
      const errorObject = JSON.parse(jsonSubstring);
      return errorObject;
  } catch (e) {
      return {message: ''};
  }
}

export const generateProfileCode = () => {
  const now = new Date();
  const epochTime = now.getTime();
  const sixDigitCode = String(epochTime).slice(-6);
  const finalCode = `SLF-${sixDigitCode}`;
  return finalCode;
}

export const formatUgandaShillings = (amount:number) => {
  if (!amount && amount !== 0) return '';

  const numericValue = Number(amount.toString().replace(/\D/g, ''));
  const formattedNumber = numericValue.toLocaleString('en-US');

  return `UGX ${formattedNumber}`;
};